export const foldIcon = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -1 30 30">
  <path fill="currentcolor" d="M9.2 14.6a1.6 1.6 0 1 1-3.2 0 1.6 1.6 0 0 1 3.2 0M16.2 14.6a1.6 1.6 0 1 1-3.2 0 1.6 1.6 0 0 1 3.2 0M23.2 14.6a1.6 1.6 0 1 1-3.2 0 1.6 1.6 0 0 1 3.2 0"/>
</svg>
`;
export const undoIcon = `
<svg viewBox="0 0 512 512">
  <path fill="currentColor" d="m90 179 1 1 1 1 2 3 60 60a21 21 0 0 0 32-28l-1-2-25-25h203l1 1v167l-1 1v1H196a21 21 0 0 0-2 42h169c23 0 42-18 44-41V191c0-24-18-43-41-44l-3-1H160l25-24c7-8 8-20 1-28l-1-2c-8-8-20-9-29-2l-2 2-60 60-2 2 1-1c-4 4-6 9-6 14v2c0 3 1 7 3 10z"/>
</svg>
`;
export const redoIcon = `
<svg viewBox="0 0 512 512">
  <path fill="currentColor" d="M423 179v1l-1 1-2 3-61 60a21 21 0 0 1-32-28l2-2 25-25H151l-2 1v167l1 1 1 1h166a21 21 0 0 1 3 42H151c-23 0-43-18-44-41V191c0-24 18-43 41-44l3-1h203l-25-24c-8-8-8-20-2-28l2-2c8-8 20-9 28-2l2 2 61 60 2 2-2-1c5 4 6 9 7 14v2c0 3-2 7-4 10z"/>
</svg>
`;
//# sourceMappingURL=icon.js.map